import React from 'react';
import sortby from 'lodash.sortby';
import { PropTypes } from 'prop-types';
import SavedSearchCard from '@molecules/SavedSearchCard';
import LoadingArea from '@molecules/LoadingArea';
import PagedRecords from '@organisms/PagedRecords';
import { BodyLarge } from '@styled';
import useMemberFull from '@hooks/useMemberFull';

const MemberProfileSiteCriteria = ({ graphID }) => {
    const { data } = useMemberFull(graphID);

    if (!data) return <LoadingArea />;

    if (data.savedSearches.length === 0)
        return <BodyLarge>{data.firstName} is not currently looking for space.</BodyLarge>;

    const renderCards = records =>
        records.map((record, index) => (
            <div className="d-flex flex-column mb-4 col-md-4" key={`site-criteria-${index}`}>
                <SavedSearchCard savedSearch={record} member={data} />
            </div>
        ));

    return (
        <div className="fade-in-fast">
            <BodyLarge style={{ marginBottom: '32px' }}>{data.firstName}'s site criteria</BodyLarge>
            <PagedRecords
                records={sortby(
                    data.savedSearches.filter(search => search.primaryInterest === 'SPACE'),
                    'createdAt'
                ).reverse()}
                recordsPerPage={3}
            >
                {records => <div className="row">{renderCards(records)}</div>}
            </PagedRecords>
        </div>
    );
};

MemberProfileSiteCriteria.propTypes = {
    graphID: PropTypes.string,
};

export default MemberProfileSiteCriteria;
